__turbopack_context__.v({
  "changeHintText": "EditableLotteryEntry-module__ZxvrLW__changeHintText",
  "collapsed": "EditableLotteryEntry-module__ZxvrLW__collapsed",
  "container": "EditableLotteryEntry-module__ZxvrLW__container",
  "entriesContainer": "EditableLotteryEntry-module__ZxvrLW__entriesContainer",
  "flipChevron": "EditableLotteryEntry-module__ZxvrLW__flipChevron",
  "lineContainer": "EditableLotteryEntry-module__ZxvrLW__lineContainer",
  "offer": "EditableLotteryEntry-module__ZxvrLW__offer",
  "onDarkBlue": "EditableLotteryEntry-module__ZxvrLW__onDarkBlue",
  "pulse": "EditableLotteryEntry-module__ZxvrLW__pulse",
  "randomise": "EditableLotteryEntry-module__ZxvrLW__randomise",
  "removeButton": "EditableLotteryEntry-module__ZxvrLW__removeButton",
  "removeContainer": "EditableLotteryEntry-module__ZxvrLW__removeContainer",
  "showToggle": "EditableLotteryEntry-module__ZxvrLW__showToggle",
  "title": "EditableLotteryEntry-module__ZxvrLW__title",
  "titleContainer": "EditableLotteryEntry-module__ZxvrLW__titleContainer",
  "titleContainerToFont": "EditableLotteryEntry-module__ZxvrLW__titleContainerToFont",
  "toggleCollapse": "EditableLotteryEntry-module__ZxvrLW__toggleCollapse",
  "variant2": "EditableLotteryEntry-module__ZxvrLW__variant2",
});
